<template>
  <div id="invite-records">

    <div class="header clearfix">
      <div class="little-title">
        <span :class="{ active: isRewardTab }" @click="isRewardTab = true">{{ $t('rewardDate') }}</span>
        <span :class="{ active: !isRewardTab }" @click="isRewardTab = false">{{ $t('friends') }}</span>
        <router-link to="/reward-rules" v-if="isRewardTab">{{ $t('rules') }}</router-link>
      </div>
    </div>
    <div class="records-component">
      <reward-records-pc v-show="isRewardTab" class="pc-show" :init-award-records-data="initAwardRecordsData"></reward-records-pc>
      <reward-records-m v-show="isRewardTab" class="phone-show" :init-award-records-data="initAwardRecordsData"></reward-records-m>
      <friend-records-pc v-show="!isRewardTab" class="pc-show" :init-invitation-records-data="initInvitationRecordsData"></friend-records-pc>
      <friend-records-m v-show="!isRewardTab" class="phone-show" :init-invitation-records-data="initInvitationRecordsData"></friend-records-m>
    </div>

  </div>
</template>

<script>
  import FriendRecordsPc from '../friendRecords/FriendRecordsPc.vue'
  import FriendRecordsM from '../friendRecords/FriendRecordsM.vue'
  import RewardRecordsPc from '../rewardRecords/RewardRecordsPc.vue'
  import RewardRecordsM from '../rewardRecords/RewardRecordsM.vue'
  import locales from './lang'

  export default {
    name: 'invite-record',
    components: {FriendRecordsPc, FriendRecordsM, RewardRecordsPc, RewardRecordsM},
    data() {
      return {
        isRewardTab: true,
        initInvitationRecordsData: '',
        initAwardRecordsData: ''
      }
    },
    locales,
    created() {
      this.getFriendRecords()
      this.getAwardRecords()
    },
    methods: {
      getFriendRecords() {
        this.$http.get('api/invitation-records?page=1').then(response => {
          this.initInvitationRecordsData = response.data
        })
      },
      getAwardRecords() {
        this.$http.get('api/award-records?page=1').then(response => {
          this.initAwardRecordsData = response.data
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/content-box";

  #invite-records {
    border: 1px solid #e0d7e3;
    border-radius: 8px;

    .header {
      .title {
        float: left;
        svg{
          margin-right:10px;
          margin-left:10px;
        }
      }
      .little-title {
        font-size: 16px;
        color: #666;
        letter-spacing: 0;
        border-bottom: 1px solid #e0d7e3;
        padding: 0 .16rem;
        line-height: .48rem;
        margin: 0;
        height: .48rem;
        position: relative;
        span {
          display: inline-block;
          line-height: .48rem;
          height: .48rem;
          cursor: pointer;
          &:nth-child(1) {
            margin-right: .24rem;
          }
          &.active {
            color: #111;
            background: linear-gradient(135deg, #416CF8 0%, #EC55FF 100%) center bottom / 36px 3px no-repeat;
          }
        }
        a {
          width: 113px;
          height: 28px;
          line-height: 26px;
          border: 1px solid #416CF8;
          border-radius: 4px;
          font-size: 14px;
          color: #416CF8;
          cursor: pointer;
          text-align: center;
          position: absolute;
          right: .16rem;
          top: .1rem;
        }
      }
    }
  }

  @media (max-width: 767px) {
    #invite-records {
      border-radius: .05rem;
      .header {
        .little-title {
          height: 44px;
          line-height: 44px;
          font-size: .14rem;
          span {
            height: 44px;
            line-height: 44px;
            &:nth-child(1) {
              margin-right: .16rem;
            }
            &.active {
              background-size: 32px 3px;
            }
          }
          a {
            width: 99px;
            height: 24px;
            line-height: 22px;
            top: 10px;
          }
        }
      }
    }
  }

  .records-component {
    @media (max-width: 767px) {
      padding: 0 .16rem;
    }
    @media (max-width: 767px) {
      .pc-show {
        display: none;
      }
    }
    @media (min-width: 768px) {
      .phone-show {
        display: none;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// InviteRecord.vue?45b2131a